<script setup>
/**
 * A device asking to be added, approved from a `?pair=` link opened on this
 * one (main.js): the device panel on its own, since there is no Settings open
 * to hold it. Everywhere else the panel lives in Settings' Sync tab.
 */
import Sheet from '../ui/Sheet.vue'
import DevicePanel from '../settings/DevicePanel.vue'
import { closeSheet } from '../../stores/state'
import { t } from '../../stores/i18n'

defineProps({ payload: { type: Object, default: () => ({}) } })
</script>

<template>
  <Sheet :title="t('device.sheetTitle')" @close="closeSheet">
    <DevicePanel :payload="payload" @done="closeSheet" />
  </Sheet>
</template>
